import React from 'react';
import { Link } from 'react-router-dom';
import FinancialPlanning from '../icons/Financial Planning_.svg';
import Accounting from '../icons/Accounting.svg';
import Auditing from '../icons/Auditing.svg';
import TaxPlanning from '../icons/Tax Planning.svg';
import Budgetting from '../icons/Budgeting & Cost_.svg';
import CashFlow from '../icons/Cash Flow Management_.svg';
import FinancialAdvisory from '../icons/Financial Planning_.svg'
import InternalControl from '../icons/Tax Planning.svg'

const services = [
  {
    icon: FinancialPlanning,
    title: 'Financial Planning & Analysis (FP&A)',
    description: 'Our financial planning and analysis (FP&A) services cover budgeting, forecasting, and financial modeling. We create and track key performance indicators (KPIs) to evaluate financial performance and support strategic decision-making, driving growth and stability.',
    href: '/financial-planning'
  },
  {
    icon: Accounting,
    title: 'Accounting & Bookkeeping',
    description: 'We provide comprehensive accounting and bookkeeping services, including general ledger management, preparation of financial statements, and account reconciliation. Our services ensure precise financial reporting and efficient month-end and year-end closing processes.',
    href: '/accounting-bookkeeping'
  },
  {
    icon: Auditing,
    title: 'Auditing',
    description: 'Our team offers detailed auditing services, including internal, external, compliance, and operational audits. Our audits ensure adherence to regulations, identify potential risks, and enhance the accuracy of your financial records.',
    href: '/auditing'
  },
  {
    icon: TaxPlanning,
    title: 'Tax Planning & Compliance',
    description: 'Our tax planning and compliance services focus on crafting effective tax strategies, handling tax preparation and filing, and providing expert tax advisory. We assist with audit support and ensure compliance with tax laws to optimize your tax outcomes.',
    href:'/tax-planning'
  },
  {
    icon: Budgetting,
    title: 'Budgeting & Cost Control',
    description: 'We offer budgeting and cost control services to create effective budgets and manage expenses. Our cost analysis and variance reporting help regulate spending and improve financial management, supporting long-term fiscal health.',
    href:'/budgeting-cost'
  },
  {
    icon: CashFlow,
    title: 'Cash Flow Management',
    description: 'We specialise in cash flow management through cash flow forecasting, working capital management, and implementing cash management solutions. Effective cash flow management ensures liquidity and operational efficiency, facilitating business growth.',
    href:'/cash-flow'
  },
  {
    icon: FinancialAdvisory,
    title: 'Financial Advisory Services',
    description: 'Our financial advisory services include guidance on mergers and acquisitions, capital raising, and business valuation. We provide financial risk management strategies to support key financial decisions and enhance business value.',
    href:'/financial-advisory'
  },
  {
    icon: InternalControl,
    title: 'Internal Controls & Compliance',
    description: 'We offer internal controls and compliance services, including evaluating control systems, monitoring compliance, and fraud prevention. Our solutions ensure strong internal controls and adherence to regulatory requirements, safeguarding your organization’s assets.',
    href:'/internal-controls'
  },
  
];

const SubServiceSectionFinance = () => {

  return (
    <section className="bg-white py-12 px-4">
    <div className="container mx-auto px-4">
      <div className="flex flex-wrap -mx-4">
        {services.map((service, index) => (
          <div
            key={index}
            className="w-full md:w-1/2 lg:w-1/4 mb-8"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="flex flex-col justify-between items-center text-center bg-white rounded-lg py-12 px-4 transform transition hover:-translate-y-2 hover:shadow-lg border border-[#13689b] mx-2 h-full">
              <div className="flex-grow">
              <img src={service.icon} alt = {service.title} className='mx-auto' />
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-left text-black">{service.description}</p>
              </div>
              <Link to={service.href} className='text-white bg-[#13689b] mt-4 px-3 py-2 rounded-md font-semibold hover:text-[#13689b] hover:bg-white hover:border hover:border-[#13689b]'>Explore Service</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  
  );
};

export default SubServiceSectionFinance;
